import Control from "../pages/main/control/control";
import Auth from "../pages/main/security/auth/auth";
import Log from "../pages/main/security/log/log";
/**
 * 系统主框架
 */
const routes = [
    {
        sort: 1,
        name: "管理控制台",
        path: "/control",
        component: Control,
        meta: {
            icon: "el-icon-monitor",
            menu: true
        }
    },
    {
        sort: 2,
        name: "系统安全",
        path: "/security",
        component: { template: "<router-view></router-view>" },
        redirect: "/security/auth",
        meta: {
            icon: "el-icon-user",
            menu: true
        },
        children: [
            {
                name: "授权管理",
                path: "/security/auth",
                component: Auth,
                meta: {
                    menu: true
                }
            },
            {
                name: "操作日志",
                path: "/security/log",
                component: Log,
                meta: {
                    menu: true
                }
            }
        ]
    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/module-main.js